/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js below...



  (function() {
    const excludedPaths = [
      '/', 
      '/pages/warranty',
      '/pages/terms-conditions',
      '/policies/terms-of-service',
      '/pages/privacy-policy'
    ];

    if (excludedPaths.includes(window.location.pathname)) {
      return;
    }

    var script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=d43b8fd6-2491-42fa-9efa-be9729220d47';
    script.async = true; // Optional, but recommended
    document.head.appendChild(script); // or document.body.appendChild(script)
  })();